import ContactModal from './ContactModal';

export default ContactModal;
